import React, {useEffect} from 'react';
import { FormGroup, Form } from 'reactstrap';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import TextField from '../../common/text-field';
import { connect } from 'react-redux';

const StickySearch = props => {

    const {
        handleSubmit,
        reset,
        push,
        search,
        clearFilters,
        setFilteredItem,
        filteredItems,
        getInventory,
        location,
    } = props;

    useEffect(() => {
        const fetchData = async () => {
            await getInventory({
                searchString: search,
                page_number: 1,
            });
        }

        if (search !== undefined) {
            fetchData();
            reset('stickySearchForm')
        }
},[filteredItems]);

    const handleSearch = () => {
        if (/\S/.test(search)) {
            if (search === undefined) {
                Promise.all([
                    clearFilters(),
                    push('/search')
                ])
            } else {
                clearFilters();
                if (location.includes('search')) {
                    setFilteredItem(search);
                }
                push(`/search?page_number=1&search_string=${search}`);
        }

        var closemyslide = document.getElementById("mySidenav");
        if (closemyslide) {
            closemyslide.classList.remove('open-side');
        }
    }
}

    return (
        <React.Fragment>
            <Form onSubmit={handleSubmit(value => handleSearch(value))}>
                <FormGroup className="navbar-input-group text-white">
                    <Field
                        name="search"
                        id="searchSticky"
                        placeholder="Search, Makes, Models"
                        component={TextField}
                        hasEmptyLabel={false}
                        noSpecialChar={true}
                        append={(
                            <i onClick={(value) => handleSearch(value)} className="fa fa-lg fa-search " />
                        )}
                    />
                </FormGroup>
            </Form>

        </React.Fragment>
    )
}

const selector = formValueSelector('stickySearchForm');


const StickySearchForm = reduxForm({
    form: 'stickySearchForm',
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
})(StickySearch);

export default connect(state => ({
    location: state.router.location.pathname,
    search: selector(state, 'search')
}))(StickySearchForm)